export default __webpack_public_path__ + "static/media/cny-prize.a57f881f.png";